import { render, staticRenderFns } from "./OntologyTreeMultiselect.vue?vue&type=template&id=3fed38fa&"
import script from "./OntologyTreeMultiselect.vue?vue&type=script&lang=js&"
export * from "./OntologyTreeMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports